import React, { useContext } from "react";
import { StateContext } from "../App";
import "./overview.css";
import CurrencyFormat from "react-currency-format";

function Overview() {
  const { state, dispatch } = useContext(StateContext);

  // Write A Reducer Function Here to Calculate
  // The sum Of the Payouts!...
  const totalPayouts =
    state.user &&
    state.user.payouts.reduce((acc, elem) => {
      return acc + elem;
    }, 0);

  const totalDeposits =
    state.user &&
    state.user.deposit.reduce((acc, elem) => {
      return acc + elem;
    }, 0);

/*   const totalBonus =
    state.user &&
    state.user.bonus.reduce((acc, elem) => {
      return acc + elem;
    }, 0);
 */
  return (
    <div className="overview">
      <div className="container">
        <h2>account overview</h2>
        <div className="divider"></div>
        <div className="overview-tabs">
          <div className="row">
            <div className="col s6 m3 l3">
              <div className="card  ">
                <span className="card-title">total deposits</span>
                <p>
                  <CurrencyFormat
                    renderText={(value) => (
                      <>
                        <p>
                          <strong>{value}</strong>
                        </p>
                      </>
                    )}
                    value={state.user ? totalDeposits : 0}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    thousandSeparator={true}
                    displayType={"text"}
                    prefix={"$"}
                  />
                </p>
              </div>
            </div>
            <div className="col s6 m3 l3">
              <div className="card  ">
                <span className="card-title">total payouts</span>
                <p>
                  <CurrencyFormat
                    renderText={(value) => (
                      <>
                        <p>
                          <strong>{value}</strong>
                        </p>
                      </>
                    )}
                    value={state.user ? totalPayouts : 0}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    thousandSeparator={true}
                    displayType={"text"}
                    prefix={"$"}
                  />
                </p>
              </div>
            </div>
            <div className="col s6 m3 l3">
              <div className="card  ">
                <span className="card-title">referals</span>
                <p>{state.user ? state.user.referral : null}</p>
              </div>
            </div>
            <div className="col s6 m3 l3">
              <div className="card  ">
                <span className="card-title">bonuses</span>
                <p>
                  <CurrencyFormat
                    renderText={(value) => (
                      <>
                        <p>
                          <strong>{value}</strong>
                        </p>
                      </>
                    )}
                    value={ state.user ? state.user.bonus : 0 }
                    decimalScale={2}
                    fixedDecimalScale={true}
                    thousandSeparator={true}
                    displayType={"text"}
                    prefix={"$"}
                  />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Overview;
